"use strict";
'kiwi public';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
let Vue = require('vue');
var _default = exports.default = Vue.component('input-confirm', {
  props: ['label', 'flipConnotation'],
  data: function data() {
    return {
      state: 'pre'
    };
  },
  computed: {
    connoteCss() {
      return {
        yes: this.flipConnotation ? 'warning' : 'primary',
        no: this.flipConnotation ? 'primary' : 'warning'
      };
    }
  },
  created() {
    if (!this.$slots.default) {
      this.state = 'prompt';
    }
  },
  methods: {
    prompt() {
      this.state = 'prompt';
    },
    complete(val) {
      this.$emit(val ? 'ok' : 'cancel');
      this.$emit('submit', val);
      this.state = 'pre';
    }
  }
});
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["utils"]) window._kiwi_exports["components"]["utils"] = {};
window._kiwi_exports["components"]["utils"]["InputConfirm"]
window._kiwi_exports.components.utils.InputConfirm = exports.default ? exports.default : exports;
